var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('base-navigation-tabs',{attrs:{"items":_vm.links}}),_c('v-card',{staticClass:"mt-3",attrs:{"min-width":"70vw","min-height":"80vh","elevation":"0"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }